/**
 * Returns the CouchDB server URL (admin credentials embedded).
 *
 * The legacy CouchDB target has been removed — all clients now use
 * couchdb.wprestamos.us regardless of any stored `couch_target`.
 *
 * @returns {string} base URL with a trailing slash
 */
export function getCouchUrl() {
  // Local CouchDB URL for development
  // "http://wilson382:browning-dunes-PATSY-chanel-instead@127.0.0.1:5984"
  return "https://admin:rf451f4e14e165dcedce2po@couchdb.wprestamos.us/";
}
